export const assetAdress = "/assets/home/";
export const stationAdress = `assets/home/stations/`;
export const IconAdress = `assets/home/icons/`;
export const firmIcons = `assets/home/firm/`;